const UNSAFE_CHARS = /[<>:"/\\|?*#%{}$!'@&+]/g;
const NON_ASCII = /[^\x20-\x7E]/g;
const REPEATED_SPACES = / {2,}/g;
const REPEATED_HYPHENS = /-{2,}/g;
const REPEATED_UNDERSCORES = /_{2,}/g;
const MAX_LENGTH = 200;

/**
 * Sanitizes a filename for safe transmission to the backend.
 * Strips unsafe characters, non-ASCII, collapses separators,
 * and enforces a max length. Preserves the file extension.
 */
export function sanitizeFileName(name: string): string {
    const dotIndex = name.lastIndexOf(".");
    const hasExtension = dotIndex > 0;
    const rawBase = hasExtension ? name.slice(0, dotIndex) : name;
    const extension = hasExtension ? name.slice(dotIndex) : "";

    const sanitized = rawBase
        .replace(NON_ASCII, "")
        .replace(UNSAFE_CHARS, "")
        .replace(REPEATED_SPACES, " ")
        .replace(REPEATED_HYPHENS, "-")
        .replace(REPEATED_UNDERSCORES, "_")
        .trim()
        .replace(/^\.+|\.+$/g, "");

    const base = sanitized || "document";
    const maxBase = MAX_LENGTH - extension.length;

    return base.slice(0, maxBase) + extension;
}
